import { CONFIG_UPDATE } from './types';
const initialState = {
    minAge: 13,
    documentPaths: {
        cms: {
            hipaalibre: {},
            rwelibre: {},
        },
        files: {
            termsOfUse: {},
            privacyNotice: {},
        },
    },
    documentUrls: {
        cms: '',
        files: '',
    },
    apiCountryUrls: {},
    supportedLanguages: [],
    supportedCountries: [],
    countries: [],
    passwordRules: [],
    validation: {
        patient: {
            firstNameMaxLength: 40,
            lastNameMaxLength: 80,
        },
    },
};
export const configReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONFIG_UPDATE:
            return {
                ...state,
                ...action.config,
            };
        default:
            return state;
    }
};
